import styled from "styled-components";
import { useCallback, useRef } from "react";
import { TextFieldLabel } from "../core/TextField";
import Button from "../core/Button";
import * as React from "react";
import { startCase } from "lodash";

const ROLE_LABEL_OVERRIDES = {
  company_admin: "CharTec Admin",
  admin: "Super Admin",
};

const CHARTEC_ROLES = ["company_admin", "admin"];
const USER_ROLES = [
  "sales",
  "human_resources",
  "operations",
  "marketing",
  "finance",
  "sales_manager",
];

const RoleEditorButtonsDiv = styled.div`
  margin-top: 2em;
`;

const RoleEditorButtonDiv = styled.div`
  margin: 5px;
`;

const RoleEditorSelect = styled.select`
  height: 200px;
`;

function RoleOption({ option }) {
  return <option value={option.value}>{option.label}</option>;
}

function roleToOption(role: string) {
  return { label: ROLE_LABEL_OVERRIDES[role] || startCase(role), value: role };
}

function RolesEditor({ roles = [], setRoles, allowAdmin = false }) {
  const userRoles = roles.filter(r => r !== "user").map(roleToOption);
  const availableRoles = (allowAdmin
    ? [...USER_ROLES, ...CHARTEC_ROLES]
    : USER_ROLES
  )
    .filter(r => !roles.includes(r))
    .map(roleToOption);

  const availableRolesSelect = useRef<HTMLSelectElement>(null);
  const userRolesSelect = useRef<HTMLSelectElement>(null);

  const addRoles = useCallback(
    function addRoles() {
      const availableRolesSelected = Array.from(
        availableRolesSelect.current.selectedOptions
      ).map(o => o.value);

      setRoles([...roles, ...availableRolesSelected]);
    },
    [setRoles, roles]
  );

  const removeRoles = useCallback(
    function removeRoles() {
      const userRolesSelected = Array.from(
        userRolesSelect.current.selectedOptions
      ).map(o => o.value);
      setRoles(roles.filter(r => !userRolesSelected.includes(r)));
    },
    [roles, setRoles]
  );

  return (
    <>
      <div className="columns is-vcentered">
        <div className="column">
          <TextFieldLabel label={"Available Roles"} />
          <RoleEditorSelect
            ref={availableRolesSelect}
            multiple
            className={"form-control"}
          >
            {availableRoles.map(r => (
              <RoleOption option={r} key={r.value} />
            ))}
          </RoleEditorSelect>
        </div>
        <div className="column is-narrow">
          <RoleEditorButtonsDiv>
            <RoleEditorButtonDiv>
              <Button onClick={removeRoles}>
                <i className="fa fa-arrow-left" />
              </Button>
            </RoleEditorButtonDiv>
            <RoleEditorButtonDiv>
              <Button onClick={addRoles}>
                <i className="fa fa-arrow-right" />
              </Button>
            </RoleEditorButtonDiv>
          </RoleEditorButtonsDiv>
        </div>
        <div className="column">
          <TextFieldLabel label={"User's Roles"} />
          <RoleEditorSelect
            multiple
            className={"form-control"}
            ref={userRolesSelect}
          >
            {userRoles.map(r => (
              <RoleOption option={r} key={r.value} />
            ))}
          </RoleEditorSelect>
        </div>
      </div>
    </>
  );
}

export default RolesEditor;



// WEBPACK FOOTER //
// ./app/javascript/components/employee/UserRolesEditor.tsx